/* eslint-disable react/prop-types */
import React from 'react';
import styles from './FilterChips.less';

/**
 * FilterChips —— 语义色快速筛选
 * ------------------------------------------------------------------
 * 照搬商家端 h5 `guidance-dashboard.vue` 的 `.filter-tag` 设计：
 * 每个选项自带语义底色（危险=浅红 / 预警=浅金 / 主要=浅蓝 / 默认=浅灰），
 * 选中态填充实色、未选中带 currentColor 描边。
 *
 * 与 FilterDropdown 的分工：
 *   · FilterDropdown → 维度切换（时间、类型、指标），值多、需要标签
 *   · FilterChips    → 少量互斥的「快速筛选」，要一眼看到全部选项
 *
 * @param options [{ value, label, tone: 'default'|'primary'|'danger'|'warning'|'success' }]
 */
const FilterChips = (props) => {
  const { options = [], value, onChange, label = '快速筛选' } = props;

  return (
    <div className={styles.wrap}>
      <span className={styles.label}>{label}：</span>
      <div className={styles.tags}>
        {options.map((o) => {
          const active = String(o.value) === String(value);
          return (
            <span
              key={o.value}
              className={`${styles.tag} ${styles[o.tone] || styles.default} ${
                active ? styles.active : ''
              }`}
                onClick={() => onChange && onChange(o.value)}
            >
              {o.label}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default FilterChips;
